import { createStyles, makeStyles } from '@material-ui/core';
import {
    INFO_MAX_WIDTH,
    INFO_WIDTH,
    TITLE_WIDTH_RATIO,
    INFO_MAX_HEIGHT,
    INFO_HEIGHT_VH,
    REMAINING_KEY,
    BASE_MAX_HEIGHT
} from '../services/constants';

const useATeamStyles = makeStyles((theme) =>
    createStyles({
        root: {
            display: 'flex',
            padding: theme.spacing(4),
            overflow: 'hidden',
            position: 'relative',
            minHeight: '100vh',

            [theme.breakpoints.down('xs')]: {
                padding: `${theme.spacing(1)}px`,
                paddingTop: theme.spacing(4),
                paddingBottom: theme.spacing(7)
            }
        },

        animatedContainer: {
            display: 'flex',
            position: 'relative',
            [theme.breakpoints.down('xs')]: {
                position: 'static'
            }
        },
        animatedDiv: { margin: `0 ${theme.spacing(2)}px` },
        ateam: {
            top: '13vw'
        },
        ateamContainer: {
            width: `${TITLE_WIDTH_RATIO - 5}%`,

            [theme.breakpoints.down('sm')]: {
                width: 'auto',
                marginLeft: theme.spacing(1),
                position: 'absolute'
            }
        },
        mainText: {
            height: 80,
            [theme.breakpoints.down('sm')]: {
                marginLeft: '30vw'
            }
        },

        infoContainer: {
            display: 'flex',
            width: `calc(60px + ${INFO_WIDTH}vw)`,
            maxWidth: INFO_MAX_WIDTH,
            [theme.breakpoints.down('sm')]: {
                maxWidth: 'auto',
                width: `90vw`
            },
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column',

                alignItems: 'center'
            }
        },
        leaderImage: {
            width: 'auto',
            height: INFO_HEIGHT_VH,
            maxHeight: INFO_MAX_HEIGHT,
            [theme.breakpoints.down('xs')]: {
                width: '60vw',
                height: 'auto'
            }
        },
        firstInfoItem: {
            marginTop: REMAINING_KEY[0] * BASE_MAX_HEIGHT,
            [theme.breakpoints.down('xs')]: {
                marginTop: REMAINING_KEY[0] * BASE_MAX_HEIGHT - 30
            }
        },

        firstLabel: { width: 120 },
        labelsContainer: { display: 'flex' },
        absoluteLabelContainer: {
            display: 'flex',
            position: 'absolute'
        },
        linkedin: { alignSelf: 'flex-end', margin: 36 },
        linkedinIcon: { width: 36, height: 36 },
        leadersInfoDesc: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            width: INFO_MAX_HEIGHT,
            [theme.breakpoints.down('xs')]: {
                maxWidth: 'auto',
                marginTop: theme.spacing(2)
            }
        },
        hide: {
            visibility: 'hidden',
            width: 1
        }
    })
);

export default useATeamStyles;
